module.exports = __webpack_public_path__ + "static/img/13.1d255b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/13.png
// module id = mPYN
// module chunks = 0